'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactStickynode = require('react-stickynode');

var _reactStickynode2 = _interopRequireDefault(_reactStickynode);

var _chemist = require('chemist');

var _AddressFormFields = require('../AddressForm/AddressFormFields');

var _AddressFormFields2 = _interopRequireDefault(_AddressFormFields);

var _AddressFormFieldsWithPostcodeLookup = require('../AddressForm/AddressFormFieldsWithPostcodeLookup');

var _AddressFormFieldsWithPostcodeLookup2 = _interopRequireDefault(_AddressFormFieldsWithPostcodeLookup);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _AddressForm = require('../AddressForm');

var _AddressForm2 = _interopRequireDefault(_AddressForm);

var _CheckoutButton = require('../CheckoutForm/CheckoutButton');

var _CheckoutButton2 = _interopRequireDefault(_CheckoutButton);

var _DeliveryForm = require('../DeliveryForm');

var _DeliveryForm2 = _interopRequireDefault(_DeliveryForm);

var _OrderSummary = require('../OrderSummary');

var _OrderSummary2 = _interopRequireDefault(_OrderSummary);

var _PaymentForm = require('../PaymentForm');

var _PaymentForm2 = _interopRequireDefault(_PaymentForm);

var _StoreCreditSummary = require('../StoreCreditSummary');

var _StoreCreditSummary2 = _interopRequireDefault(_StoreCreditSummary);

var _localisedPaths = require('../../helpers/localisedPaths');

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormInput = require('../FormInput');

var _presentation = require('../../actions/presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckoutForm = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(CheckoutForm, _React$Component);

  function CheckoutForm() {
    (0, _classCallCheck3.default)(this, CheckoutForm);
    return (0, _possibleConstructorReturn3.default)(this, (CheckoutForm.__proto__ || (0, _getPrototypeOf2.default)(CheckoutForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(CheckoutForm, [{
    key: 'onSubmitProxy',
    value: function onSubmitProxy(e) {
      if (this.submitCheckoutForm) {
        e.preventDefault();
        return this.submitCheckoutForm();
      }

      return this.props.onSubmit(e);
    }
  }, {
    key: 'setCheckoutFormSubmitter',
    value: function setCheckoutFormSubmitter() {
      var submit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.submitCheckoutForm = submit;
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      var _this2 = this;

      var lng = this.props.params.lng;
      var store = this.props.config.store;

      return function (_ref) {
        var _context;

        var children = _ref.children;
        return _react2.default.createElement(
          _this2.props.Form,
          {
            id: 'checkoutForm',
            styleName: 'p-checkout',
            action: (0, _localisedPaths.localisedAction)(_this2.props.config.store, 'checkout/' + _this2.props.order.state, lng),
            onSubmit: function onSubmit(e) {
              return _this2.onSubmitProxy(e);
            },
            method: 'post'
          },
          _react2.default.createElement(
            'div',
            { styleName: 'o-checkoutSummary' },
            _react2.default.createElement(
              _reactStickynode2.default,
              { top: 60, bottomBoundary: '#checkoutForm' },
              _react2.default.createElement(
                'div',
                { styleName: 'm-summaryPanel' },
                _react2.default.createElement(_StoreCreditSummary2.default, { simple: true, user: _this2.props.user }),
                _react2.default.createElement(_OrderSummary2.default, {
                  onToggle: (_context = _this2.props).onOrderSummaryToggle.bind(_context),
                  order: _this2.props.order,
                  orderSummaryVisible: _this2.props.presentation.orderSummaryVisible,
                  onCouponApply: (_context = _this2.props).onCouponApply.bind(_context),
                  onCouponRemove: (_context = _this2.props).onCouponRemove.bind(_context),
                  step: _this2.props.step,
                  tempPromotionsEnabledSet: _this2.props.tempPromotionsEnabledSet
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'm-checkoutActions', className: 'hidden-xs' },
                  _react2.default.createElement(_CheckoutButton2.default, { step: _this2.props.step })
                ),
                store.displayCheckoutHelp && _react2.default.createElement(
                  'div',
                  { styleName: 'm-checkoutActions' },
                  _react2.default.createElement(
                    _FormInput.Button,
                    {
                      type: 'button',
                      onClick: _this2.showCheckoutHelp.bind(_this2),
                      styleName: 'checkout-help-button'
                    },
                    'What can I do if I\'m having trouble ordering online?'
                  )
                ),
                store.displayCheckoutNotice && _react2.default.createElement(
                  'div',
                  { styleName: 'm-checkoutActions' },
                  _react2.default.createElement(
                    _FormInput.Button,
                    {
                      type: 'button',
                      onClick: _this2.showCheckoutNotice.bind(_this2),
                      styleName: 'checkout-help-button'
                    },
                    'Important Notice \u2013 Bank Holiday Delivery'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'o-checkoutForm checkoutForm-' + _this2.props.step + '-step' },
            children,
            _react2.default.createElement(
              'div',
              { styleName: 'm-checkoutActions', className: 'visible-xs' },
              _react2.default.createElement(_CheckoutButton2.default, {
                step: _this2.props.step,
                displayTotal: _this2.props.order.displayTotal,
                mobile: true
              })
            )
          )
        );
      };
    }
  }, {
    key: 'showCheckoutHelp',
    value: function showCheckoutHelp() {
      this.props.dispatch((0, _presentation.showCheckoutHelp)());
    }
  }, {
    key: 'showCheckoutNotice',
    value: function showCheckoutNotice() {
      this.props.dispatch((0, _presentation.showCheckoutNotice)());
    }
  }, {
    key: 'postCodeServiceFeatureToggledComponent',
    value: function postCodeServiceFeatureToggledComponent() {
      var postCodeLookupEnabledMarkets = this.props.config.store.postCodeLookupEnabledMarkets;
      return postCodeLookupEnabledMarkets ? _AddressFormFieldsWithPostcodeLookup2.default : _AddressFormFields2.default;
    }
  }, {
    key: 'render',
    value: function render() {
      var _context2,
          _this3 = this;

      this.setCheckoutFormSubmitter();

      var Container = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true })(this.getContainer());

      switch (this.props.step) {
        case 'address':
          return _react2.default.createElement(this.props.AddressForm, {
            Container: Container,
            billAddresses: this.props.billAddresses,
            billAddressDetail: this.props.billAddressDetail,
            shipAddresses: this.props.shipAddresses,
            shipAddressDetail: this.props.shipAddressDetail,
            order: this.props.order,
            errors: this.props.errors,
            country: this.props.country,
            user: this.props.user,
            onGetAddresses: (_context2 = this.props).onGetAddresses.bind(_context2),
            onGetAddress: (_context2 = this.props).onGetAddress.bind(_context2),
            FormFieldsComponent: this.postCodeServiceFeatureToggledComponent.call(this),
            tempPickupLocatorSet: this.props.tempPickupLocatorSet
          });
        case 'delivery':
          return _react2.default.createElement(
            Container,
            null,
            _react2.default.createElement(_DeliveryForm2.default, { order: this.props.order })
          );
        case 'payment':
          return _react2.default.createElement(
            Container,
            null,
            _react2.default.createElement(_PaymentForm2.default, {
              flash: this.props.flash,
              order: this.props.order,
              params: this.props.params,
              dispatch: this.props.dispatch,
              presentation: this.props.presentation,
              setCheckoutFormSubmitter: function setCheckoutFormSubmitter(submit) {
                return _this3.setCheckoutFormSubmitter(submit);
              }
            })
          );
        default:
          return '';
      }
    }
  }]);
  return CheckoutForm;
}(_react2.default.Component), _class2.propTypes = {
  onSubmit: _react.PropTypes.func.isRequired,
  onOrderSummaryToggle: _react.PropTypes.func.isRequired,
  order: _react.PropTypes.object.isRequired,
  presentation: _react.PropTypes.object.isRequired,
  country: _react.PropTypes.object,
  step: _react.PropTypes.string.isRequired,
  error: _react.PropTypes.object,
  user: _react.PropTypes.object,
  onCouponApply: _react.PropTypes.func,
  onCouponRemove: _react.PropTypes.func,
  onGetAddresses: _react.PropTypes.func,
  onGetAddress: _react.PropTypes.func,
  AddressForm: _react.PropTypes.element,
  flash: _react.PropTypes.object,
  Form: _react.PropTypes.element
}, _class2.defaultProps = {
  onSubmit: function onSubmit() {},
  onOrderSummaryToggle: function onOrderSummaryToggle() {},
  onCouponApply: function onCouponApply() {},
  onCouponRemove: function onCouponRemove() {},
  onGetAddresses: function onGetAddresses() {},
  onGetAddress: function onGetAddress() {},
  AddressForm: _AddressForm2.default,
  Form: _Form2.default
}, _temp)) || _class) || _class);
exports.default = CheckoutForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutForm/index.js
// module id = 2274
// module chunks = 0